import React, { Component } from 'react';
import { ArcaLink } from '../Fields/ArcaLink';

export class PageLink extends Component {

    constructor(props) {
        super(props);
        this.state = { text: null, color: this.props.color ?? 'secondary' };
    }

    render() {

        return (
            <span>
                <ArcaLink
                    size={this.props.size}
                    color={this.props.color}
                    onClick={this.props.onClick} to={this.props.link}
                    text={this.props.text}
                    link={this.props.link} />
            </span>
        );
    }
}